/* CBC — panier tiroir.

   Rendu depuis `window.CBC_CART` : ouvrir ne coûte aucune requête. Aucun verrou sur les
   quantités, la quantité finale part après 260 ms d'inactivité.

   Cadeau : ajouté automatiquement au seuil, retiré en dessous, après chaque réponse serveur.

   Code promo : on juge à la variation du total, pas à la présence d'une remise de niveau
   commande. Une remise « produit — pourcentage » n'apparaît que dans les allocations de
   ligne, et la contrôler au niveau commande déclarait à tort le code invalide.

   Paiement : `POST /cart` natif, doublé d'une soumission programmatique. */
(function () {
  "use strict";

  var CFG = window.CBC_CART_CONFIG || {};
  var GIFT_IDS = CFG.giftIds || [];
  var SHIP_MIN = CFG.freeShipMin || 2;
  var GIFT_MIN = CFG.giftMin || CFG.freeShipMin || 2;
  var UNIT = CFG.unitCents || 0;
  var EXTRA = CFG.extraCents || 0;
  var TIERS = CFG.tiers || {};
  var cart = window.CBC_CART || { items: [], item_count: 0 };
  var internal = false, lastFocus = null, giftGuard = false;
  var pending = {}, flushT = null, inFlight = false;
  var variantCache = {}, moreOpen = {};

  var GIFT_ICON = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"'
    + ' stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
    + '<path d="M20 12v9H4v-9"/><rect x="2" y="7" width="20" height="5" rx="1"/><path d="M12 21V7"/>'
    + '<path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/>'
    + '<path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>';
  var PLUS_ICON = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"'
    + ' stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';

  var root = document.querySelector("[data-cbcd]");
  var scrim = document.querySelector("[data-cbcd-scrim]");
  if (!root || !scrim) return;

  var rawFetch = window.fetch.bind(window);

  var $ = function (s, r) { return (r || root).querySelector(s); };
  var itemsEl = $("[data-cbcd-items]");
  var countEl = $("[data-cbcd-count]");
  var shipEl = $("[data-cbcd-ship]");
  var upsellEl = $("[data-cbcd-upsell]");

  var nfCache = {};
  function money(c) {
    var cur = cart.currency || "EUR";
    if (!(cur in nfCache)) {
      try {
        nfCache[cur] = new Intl.NumberFormat(document.documentElement.lang || "fr", {
          style: "currency", currency: cur
        });
      } catch (e) { nfCache[cur] = null; }
    }
    var nf = nfCache[cur];
    return nf ? nf.format(c / 100) : (c / 100).toFixed(2).replace(".", ",") + "\u00a0€";
  }

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (m) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[m];
    });
  }
  function isGift(it) { return GIFT_IDS.indexOf(it.variant_id) !== -1; }
  function hasGift() { return (cart.items || []).some(isGift); }
  function img(src, w) {
    if (!src) return "";
    return src.replace(/(\.(?:jpg|jpeg|png|webp|gif))(\?|$)/i, "_" + w + "x$1$2");
  }
  function bookCount() {
    var n = 0;
    (cart.items || []).forEach(function (it) { if (!isGift(it)) n += it.quantity; });
    return n;
  }

  function tierTotal(q) {
    if (q <= 0) return 0;
    if (TIERS[q] != null) return TIERS[q];
    if (TIERS[4] != null && EXTRA) return TIERS[4] + (q - 4) * EXTRA;
    return q * UNIT;
  }

  function nextOfferLabel() {
    var next = bookCount() + 1;
    var parts = [];
    if (UNIT > 0) {
      var pct = Math.round((1 - tierTotal(next) / (next * UNIT)) * 100);
      if (pct > 0) parts.push("\u2212" + pct + "\u00a0%");
    }
    if (next >= GIFT_MIN && !hasGift()) parts.push("le jeu offert");
    return parts.length
      ? "Ajoutez un livre et obtenez " + parts.join(" + ")
      : "Ajoutez un autre livre";
  }

  function enforceGift() {
    if (giftGuard || !GIFT_IDS.length) return;
    var gifts = (cart.items || []).filter(isGift);
    var n = bookCount();
    if (n >= GIFT_MIN && !gifts.length) {
      giftGuard = true;
      addVariant(GIFT_IDS[0], 1).then(function () { giftGuard = false; });
      return;
    }
    if (gifts.length && n < GIFT_MIN) {
      giftGuard = true;
      gifts.forEach(function (it) { setQty(it.key, 0); });
      window.setTimeout(function () { giftGuard = false; }, 1000);
    }
  }

  function loadVariants(handle) {
    variantCache[handle] = null;
    rawFetch("/products/" + handle + ".js")
      .then(function (r) { return r.json(); })
      .then(function (p) {
        variantCache[handle] = (p.variants || []).filter(function (v) { return v.available; });
        render();
      })
      .catch(function () { variantCache[handle] = []; });
  }

  function render() {
    var paid = [], gifts = [], books = 0;
    (cart.items || []).forEach(function (it) {
      if (isGift(it)) { gifts.push(it); } else { paid.push(it); books += it.quantity; }
    });

    var groups = [], gix = {};
    paid.forEach(function (it) {
      if (gix[it.product_id] == null) {
        gix[it.product_id] = groups.length;
        groups.push({ handle: it.handle, vars: [], vix: {} });
      }
      var g = groups[gix[it.product_id]];
      if (g.vix[it.variant_id] == null) {
        g.vix[it.variant_id] = g.vars.length;
        g.vars.push({
          vid: it.variant_id,
          name: it.variant_title && it.variant_title !== "Default Title" ? it.variant_title : it.product_title,
          image: it.image, qty: 0, final: 0, orig: 0, keys: []
        });
      }
      var v = g.vars[g.vix[it.variant_id]];
      v.qty += it.quantity;
      v.final += it.final_line_price;
      v.orig += it.original_line_price;
      v.keys.push(it.key);
    });

    var html = "";
    if (!paid.length && !gifts.length) html = '<div class="cbcd-empty">Votre panier est vide.</div>';

    groups.forEach(function (g) {
      var n = g.vars.reduce(function (s, v) { return s + v.qty; }, 0);
      html += '<article class="cbcd-prod">';
      if (g.vars.length > 1) {
        html += '<p class="cbcd-sum">' + n + " exemplaires \u00b7 " + g.vars.length + " destinataires</p>";
      }
      g.vars.forEach(function (v) {
        var save = v.orig - v.final;
        var keys = esc(v.keys.join("|"));
        html +=
          '<div class="cbcd-v">' +
            (v.image ? '<img src="' + esc(img(v.image, 160)) + '" alt="" loading="lazy">' : "<span></span>") +
            '<div class="cbcd-mid">' +
              '<div class="cbcd-name">' + esc(v.name) + "</div>" +
              '<div class="cbcd-qty">' +
                '<span class="cbcd-step">' +
                  '<button type="button" data-act="dec" data-keys="' + keys + '" aria-label="Retirer un">\u2212</button>' +
                  "<span>" + v.qty + "</span>" +
                  '<button type="button" data-act="inc" data-keys="' + keys + '" aria-label="Ajouter un">+</button>' +
                "</span>" +
                '<button type="button" class="cbcd-trash" data-act="del" data-keys="' + keys + '" aria-label="Supprimer">' +
                  '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16M10 11v6M14 11v6M5 7l1 13h12l1-13M9 7V4h6v3"/></svg>' +
                "</button>" +
              "</div></div>" +
            '<div class="cbcd-price">' +
              (save > 0 ? '<span class="cbcd-cut">\u2212' + money(save) + "</span>" : "") +
              "<b>" + money(v.final) + "</b>" +
              (save > 0 ? "<s>" + money(v.orig) + "</s>" : "") +
            "</div></div>";
      });

      var vars = g.handle ? variantCache[g.handle] : null;
      if (vars && vars.length > 1) {
        var open = !!moreOpen[g.handle];
        var opts = '<option value="" selected disabled>S\u00e9lectionner votre livre</option>'
          + vars.map(function (v) {
              return '<option value="' + v.id + '">' + esc(v.title) + "</option>";
            }).join("");
        html +=
          '<div class="cbcd-more"' + (open ? " data-open" : "") + ">" +
            '<select class="cbcd-mini cbcd-morevar" data-morevar="' + esc(g.handle) + '"' +
              ' aria-label="Destinataire à ajouter"' + (open ? "" : " hidden") + ">" + opts + "</select>" +
            '<button type="button" data-act="more" data-handle="' + esc(g.handle) + '">' +
              (open ? "" : PLUS_ICON) +
              " " + esc(open ? "Ajouter" : nextOfferLabel()) +
            "</button>" +
          "</div>";
      }
      html += "</article>";
    });

    gifts.forEach(function (it) {
      html +=
        '<article class="cbcd-gift">' +
          (it.image ? '<img src="' + esc(img(it.image, 160)) + '" alt="" loading="lazy">' : "<span></span>") +
          '<div><div class="t">' + esc(it.product_title) + "</div>" +
          '<div class="s">' + GIFT_ICON + " Offert</div></div>" +
          "<b>" + money(0) + "</b>" +
        "</article>";
    });

    itemsEl.innerHTML = html;

    groups.forEach(function (g) {
      if (g.handle && variantCache[g.handle] === undefined) loadVariants(g.handle);
    });

    var done = books >= SHIP_MIN;
    var pct = Math.min(100, SHIP_MIN ? (books / SHIP_MIN) * 100 : 100);
    $("[data-cbcd-fill]").style.width = pct + "%";
    $("[data-cbcd-knob]").style.left = pct + "%";
    if (done) shipEl.setAttribute("data-done", ""); else shipEl.removeAttribute("data-done");
    var left = SHIP_MIN - books;
    $("[data-cbcd-shiptxt]").innerHTML = done
      ? "Livraison offerte"
      : (left === 1
          ? "Plus qu'<b>un journal</b> pour la livraison offerte"
          : "Plus que <b>" + left + " journaux</b> pour la livraison offerte");

    var save = (cart.original_total_price || 0) - (cart.total_price || 0);
    var titles = (cart.cart_level_discount_applications || [])
      .map(function (a) { return a.title; }).filter(Boolean);
    countEl.textContent = cart.item_count || 0;
    $("[data-cbcd-sub]").textContent = money(cart.total_price || 0);
    $("[data-cbcd-subcompare]").textContent = save > 0 ? money(cart.original_total_price) : "";
    $("[data-cbcd-cutrow]").style.display = save > 0 ? "" : "none";
    $("[data-cbcd-cuttag]").textContent = titles.length
      ? titles[0]
      : books + (books > 1 ? " Livres" : " Livre");
    $("[data-cbcd-cut]").textContent = "\u2212" + money(save);
    $("[data-cbcd-total]").textContent = money(cart.total_price || 0);
    $("[data-cbcd-go]").disabled = !((cart.items || []).length > 0);
    if (upsellEl) upsellEl.hidden = !(cart.item_count > 0);
    syncUpsell();
  }

  function post(url, body) {
    internal = true;
    return rawFetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j && (j.description || j.message) ? j.description || j.message : "HTTP " + r.status);
        return j;
      });
    }).then(function (j) { internal = false; return j; },
            function (e) { internal = false; throw e; });
  }

  function lineByKey(key) {
    return (cart.items || []).filter(function (it) { return it.key === key; })[0] || null;
  }

  function setQty(key, qty) {
    qty = Math.max(0, qty);
    (cart.items || []).forEach(function (it) { if (it.key === key) it.quantity = qty; });
    cart.items = (cart.items || []).filter(function (it) { return it.quantity > 0; });
    render();
    pending[key] = qty;
    window.clearTimeout(flushT);
    flushT = window.setTimeout(flush, 260);
  }

  function flush() {
    if (inFlight) { flushT = window.setTimeout(flush, 120); return; }
    var keys = Object.keys(pending);
    if (!keys.length) return;
    var batch = pending; pending = {};
    inFlight = true; root.setAttribute("data-busy", "");
    var chain = Promise.resolve();
    keys.forEach(function (k) {
      chain = chain.then(function () {
        return post("/cart/change.js", { id: k, quantity: batch[k] }).then(function (c) { cart = c; });
      });
    });
    chain
      .catch(function () {
        return rawFetch("/cart.js").then(function (r) { return r.json(); }).then(function (c) { cart = c; });
      })
      .then(function () {
        inFlight = false; root.removeAttribute("data-busy"); render();
        if (Object.keys(pending).length) { flush(); return; }
        enforceGift();
      });
  }

  function addVariant(id, qty) {
    if (!id) return Promise.resolve();
    root.setAttribute("data-busy", "");
    return post("/cart/add.js", { items: [{ id: id, quantity: qty || 1 }] })
      .then(function () { return rawFetch("/cart.js").then(function (r) { return r.json(); }); })
      .then(function (c) { cart = c; })
      .catch(function (e) { showError(e.message); })
      .then(function () { root.removeAttribute("data-busy"); render(); enforceGift(); });
  }

  function removeVariant(id) {
    (cart.items || []).filter(function (it) { return it.variant_id === id; })
      .forEach(function (it) { setQty(it.key, 0); });
  }

  function showError(msg) {
    var e = $("[data-cbcd-err]");
    if (!e) return;
    e.textContent = msg || "";
    e.style.display = msg ? "" : "none";
  }

  function upsellVariantId() {
    var sel = $("[data-cbcd-upvar]");
    if (sel) return parseInt(sel.value, 10);
    var tog = $("[data-cbcd-uptog]");
    return tog ? parseInt(tog.getAttribute("data-variant"), 10) : 0;
  }
  function upsellInCart() {
    var pid = upsellEl && upsellEl.getAttribute("data-product");
    if (!pid) return null;
    return (cart.items || []).filter(function (it) { return String(it.product_id) === pid; })[0] || null;
  }
  function syncUpsell() {
    var tog = $("[data-cbcd-uptog]");
    if (!tog) return;
    var line = upsellInCart();
    if (line) tog.setAttribute("data-on", ""); else tog.removeAttribute("data-on");
    var sel = $("[data-cbcd-upvar]");
    if (sel && line) sel.value = line.variant_id;
  }

  function inIframe() {
    try { return window.top !== window.self; } catch (e) { return true; }
  }

  function goToCheckout() {
    if (!(cart.items || []).length) return;
    showError("");
    if (inIframe()) {
      try {
        window.top.location.href = "/checkout";
        return;
      } catch (e) {
        showError("L'aper\u00e7u de l'\u00e9diteur bloque le paiement. Ouvrez la boutique dans un onglet normal.");
        return;
      }
    }
    var f = document.createElement("form");
    f.method = "post";
    f.action = "/cart";
    f.style.display = "none";
    var i = document.createElement("input");
    i.type = "hidden"; i.name = "checkout"; i.value = "1";
    f.appendChild(i);
    document.body.appendChild(f);
    f.submit();
    window.setTimeout(function () { window.location.href = "/checkout"; }, 1200);
  }

  var goBtn = $("[data-cbcd-go]");
  if (goBtn) {
    goBtn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      goToCheckout();
    });
  }

  itemsEl.addEventListener("click", function (e) {
    if (!e.target || !e.target.closest) return;
    var b = e.target.closest("button[data-act]"); if (!b) return;
    var act = b.getAttribute("data-act");

    if (act === "more") {
      var h = b.getAttribute("data-handle");
      if (!moreOpen[h]) {
        moreOpen[h] = true;
        render();
        var sel0 = itemsEl.querySelector('[data-morevar="' + h + '"]');
        if (sel0) sel0.focus();
        return;
      }
      var sel = itemsEl.querySelector('[data-morevar="' + h + '"]');
      if (!sel || !sel.value) { if (sel) sel.focus(); return; }
      moreOpen[h] = false;
      addVariant(parseInt(sel.value, 10), 1);
      return;
    }

    var keys = (b.getAttribute("data-keys") || "").split("|").filter(Boolean);
    if (!keys.length) return;
    if (act === "del") { keys.forEach(function (k) { setQty(k, 0); }); return; }
    if (act === "inc") {
      var first = lineByKey(keys[0]);
      if (first) setQty(first.key, first.quantity + 1);
      return;
    }
    for (var i = keys.length - 1; i >= 0; i--) {
      var l = lineByKey(keys[i]);
      if (l && l.quantity > 0) { setQty(l.key, l.quantity - 1); return; }
    }
  });

  root.addEventListener("click", function (e) {
    if (!e.target || !e.target.closest) return;
    var tog = e.target.closest("[data-cbcd-uptog]");
    if (tog) {
      var line = upsellInCart();
      if (line) removeVariant(line.variant_id); else addVariant(upsellVariantId(), 1);
      return;
    }
    if (e.target.closest("[data-cbcd-close]")) close();
  });

  root.addEventListener("change", function (e) {
    if (!e.target.matches("[data-cbcd-upvar]")) return;
    var line = upsellInCart();
    if (!line) return;
    var next = parseInt(e.target.value, 10);
    if (next === line.variant_id) return;
    root.setAttribute("data-busy", "");
    post("/cart/change.js", { id: line.key, quantity: 0 })
      .then(function () { return post("/cart/add.js", { items: [{ id: next, quantity: line.quantity }] }); })
      .then(function () { return rawFetch("/cart.js").then(function (r) { return r.json(); }); })
      .then(function (c) { cart = c; })
      .catch(function (err) { showError(err.message); })
      .then(function () { root.removeAttribute("data-busy"); render(); });
  });

  /* Une remise peut arriver au niveau commande OU au niveau ligne selon la façon dont le
     code est configuré dans l'admin. On compare donc les totaux avant/après : c'est le seul
     signal fiable pour les deux cas. */
  function discountSignature(c) {
    return [
      c.total_price,
      c.total_discount,
      (c.cart_level_discount_applications || []).length
    ].join("|");
  }

  var promoBtn = $("[data-cbcd-promo-go]");
  if (promoBtn) {
    promoBtn.addEventListener("click", function () {
      var input = $("[data-cbcd-promo]");
      var code = (input.value || "").trim();
      if (!code) return;
      showError("");
      root.setAttribute("data-busy", "");
      var before = discountSignature(cart);
      rawFetch("/discount/" + encodeURIComponent(code))
        .then(function () { return rawFetch("/cart.js").then(function (r) { return r.json(); }); })
        .then(function (c) {
          cart = c; render();
          if (discountSignature(c) === before) {
            showError("Ce code ne s'applique pas \u00e0 ce panier.");
          } else {
            input.value = "";
          }
        })
        .catch(function () { showError("Le code n'a pas pu \u00eatre appliqu\u00e9."); })
        .then(function () { root.removeAttribute("data-busy"); });
    });
  }

  function setInert(on) {
    [".page-wrapper", "#header-group", "footer"].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (el && "inert" in el) el.inert = on;
    });
  }

  function open() {
    if (root.hasAttribute("data-open")) return;
    lastFocus = document.activeElement;
    root.hidden = false; scrim.hidden = false;
    requestAnimationFrame(function () {
      root.setAttribute("data-open", ""); scrim.setAttribute("data-open", "");
    });
    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";
    setInert(true);
    var c = $("[data-cbcd-close]"); if (c) c.focus();
  }
  function close() {
    root.removeAttribute("data-open"); scrim.removeAttribute("data-open");
    document.documentElement.style.overflow = "";
    document.body.style.overflow = "";
    setInert(false);
    window.setTimeout(function () { root.hidden = true; scrim.hidden = true; }, 280);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  scrim.addEventListener("click", close);
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && root.hasAttribute("data-open")) close();
  });

  document.addEventListener("click", function (e) {
    if (!e.target || !e.target.closest) return;
    var t = e.target.closest('a[href$="/cart"], a[href*="/cart?"], [data-cbcd-open]');
    if (!t) return;
    e.preventDefault(); e.stopPropagation();
    refresh().then(open);
  }, true);

  function refresh() {
    return rawFetch("/cart.js").then(function (r) { return r.json(); })
      .then(function (c) { cart = c; render(); enforceGift(); })
      .catch(function () {});
  }

  ["cart-drawer-component", "#cart-drawer", ".cart-drawer"].forEach(function (sel) {
    var el = document.querySelector(sel);
    if (el) { el.style.display = "none"; el.setAttribute("aria-hidden", "true"); }
  });

  window.fetch = function (input, init) {
    var url = "";
    try { url = typeof input === "string" ? input : (input && input.url) || ""; } catch (e) {}
    var p = rawFetch(input, init);
    if (!internal && /\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function (r) {
        if (!r || !r.ok) return;
        refresh().then(function () { if (/\/cart\/add/.test(url)) open(); });
      }).catch(function () {});
    }
    return p;
  };

  window.CBCCart = {
    open: function () { return refresh().then(open); },
    close: close,
    refresh: refresh,
    checkout: goToCheckout,
    add: function (items) {
      return post("/cart/add.js", { items: items }).then(function () { return refresh(); }).then(open);
    }
  };

  if (/^\/cart\/?$/.test(window.location.pathname)) {
    window.setTimeout(function () { refresh().then(open); }, 0);
  }

  render();
  enforceGift();
})();
